import { useEffect, useState } from "react";
import { RefreshCw, X } from "lucide-react";

/** Avvisa senza ricaricare automaticamente una preparazione HACCP non ancora salvata. */
export const PWAUpdateNotice = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    let active = true;
    const currentBundle = [...document.scripts]
      .map(script => script.src.split("/").pop())
      .find(filename => /^main\.[a-z0-9]+\.js$/.test(filename) || filename === "bundle.js");

    const checkForUpdate = async () => {
      let availableBundle = currentBundle;
      try {
        const response = await fetch(`/asset-manifest.json?version_check=${Date.now()}`, { cache: "no-store" });
        if (response.ok && response.headers.get("content-type")?.includes("application/json")) {
          const manifest = await response.json();
          availableBundle = manifest.files?.["main.js"]?.split("/").pop() || currentBundle;
        }
      } catch { /* L'assenza di rete non deve interrompere la preparazione. */ }
      if (!active) return;
      if (currentBundle && availableBundle && currentBundle !== availableBundle) {
        setUpdateAvailable(true);
        return;
      }
      navigator.serviceWorker.register(`/sw.js?v=${encodeURIComponent(availableBundle || "v3")}`, {
        updateViaCache: "none",
      }).then(registration => registration.update()).catch(() => {});
    };

    checkForUpdate();
    const interval = window.setInterval(checkForUpdate, 5 * 60 * 1000);
    const onVisible = () => { if (document.visibilityState === "visible") checkForUpdate(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      active = false;
      window.clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  if (!updateAvailable || dismissed) return null;
  return (
    <div role="status" data-testid="pwa-update-notice" className="fixed bottom-4 left-4 right-4 z-[12000] max-w-md mx-auto border border-emerald-300 bg-slate-950 text-white p-4 shadow-xl rounded-md flex items-center gap-3">
      <div className="flex-1 min-w-0" data-testid="pwa-update-message">
        <strong className="block text-sm !text-white" data-testid="pwa-update-title">Aggiornamento disponibile</strong>
        <span className="block text-xs text-slate-200">Salva il lavoro in corso prima di aggiornare.</span>
      </div>
      <button type="button" onClick={() => window.location.reload()} data-testid="pwa-update-now-button" className="text-sm font-semibold bg-emerald-600 hover:bg-emerald-500 text-white px-3 py-2 rounded-md flex items-center gap-1 transition-colors">
        <RefreshCw className="w-4 h-4" /> Aggiorna
      </button>
      <button type="button" onClick={() => setDismissed(true)} aria-label="Più tardi" data-testid="pwa-update-later-button" className="p-2 rounded-md !text-white hover:bg-white/15 transition-colors">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};